const INPUT_TYPES = [window.HTMLInputElement, window.HTMLSelectElement, window.HTMLTextAreaElement];
export function triggerInputChange(node, value = "") {
    // only process the change on elements we know have a value setter in their constructor
    if (INPUT_TYPES.includes(node.__proto__.constructor)) {
        const setValue = Object.getOwnPropertyDescriptor(node.__proto__, "value").set;
        const event = new Event("input", { bubbles: true });
        setValue.call(node, value);
        node.dispatchEvent(event);
    }
}
const MOUSE_CLICK_EVENTS = ["mousedown", "focus", "click", "mouseup"];
export function triggerClickEvent(element, x, y) {
    for (const event of MOUSE_CLICK_EVENTS) {
        const newEvent = new MouseEvent(event, {
            view: element.ownerDocument.defaultView,
            bubbles: true,
            cancelable: true,
            buttons: 1,
            clientX: x,
            clientY: y
        });
        newEvent.dispatcher = "html-gl";
        element.dispatchEvent(newEvent);
    }
}
function resolveElementPoint(el) {
    let point = { x: 0, y: 0 };
    if (el) {
        if (typeof el.getCenterPoint === "function") {
            point = el.getCenterPoint();
        }
        else if (el.x !== undefined && el.y !== undefined) {
            point = el;
        }
    }
    return point;
}
export function triggerMouseEvent(node, type, el) {
    // const rect = node.getBoundingClientRect();
    const point = resolveElementPoint(el);
    const event = new MouseEvent(type, {
        clientX: /* rect.left + */ point.x,
        clientY: /* rect.top + */ point.y,
        cancelable: true,
        bubbles: true,
        view: node.ownerDocument.defaultView
    });
    event.dispatcher = "html-gl";
    node.dispatchEvent(event);
}
export function getTextSelection(input, options) {
    const offset = getInputOffset();
    let topPos = offset.top;
    let leftPos = offset.left;
    const width = getInputCSS("width", true);
    const height = getInputCSS("height", true);
    // Styles to simulate a node in an input field
    // use pre-wrap instead of wrap for white-space to support wrapping in textareas
    let cssDefaultStyles = "white-space:pre-wrap;padding:0;margin:0;";
    const listOfModifiers = [
        "direction",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-variant",
        "font-weight",
        "font-style",
        "letter-spacing",
        "line-height",
        "text-align",
        "text-indent",
        "text-transform",
        "word-wrap",
        "word-spacing"
    ];
    topPos += getInputCSS("padding-top", true);
    topPos += getInputCSS("border-top-width", true);
    leftPos += getInputCSS("padding-left", true);
    leftPos += getInputCSS("border-left-width", true);
    leftPos += 1; // Seems to be necessary
    for (const property of listOfModifiers) {
        cssDefaultStyles += property + ":" + getInputCSS(property) + ";";
    }
    // End of CSS variable checks
    const text = input.value;
    const textLen = text.length;
    const fakeClone = document.createElement("div");
    const fakeRanges = [];
    if ("windowCoords" in options) {
        options.windowCoords;
        for (let pos = 0; pos < textLen; pos++) {
            fakeRanges.push(appendPart(pos, pos + 1));
        }
    }
    else {
        if (options.selectionStart > 0)
            appendPart(0, options.selectionStart);
        fakeRanges.push(appendPart(options.selectionStart, options.selectionEnd));
        if (textLen > options.selectionEnd)
            appendPart(options.selectionEnd, textLen);
    }
    // Styles to inherit the font styles of the element
    fakeClone.style.cssText = cssDefaultStyles;
    // Styles to position the text node at the desired position
    fakeClone.style.position = "absolute";
    fakeClone.style.top = topPos + "px";
    fakeClone.style.left = leftPos + "px";
    fakeClone.style.width = width + "px";
    fakeClone.style.height = height + "px";
    document.body.appendChild(fakeClone);
    if ("windowCoords" in options) {
        for (let i = 0; i < fakeRanges.length; i++) {
            const rect = fakeRanges[i].getBoundingClientRect();
            if (options.windowCoords.x <= rect.left + rect.width * 0.5) {
                fakeClone.remove();
                return {
                    start: i,
                    end: i,
                    rect
                };
            }
        }
        // jump to end of input
        const start = fakeRanges.length;
        const end = start;
        const lastRect = fakeRanges[fakeRanges.length - 1].getBoundingClientRect();
        const rect = new DOMRect(lastRect.x + lastRect.width, lastRect.y, lastRect.width, lastRect.height);
        fakeClone.remove();
        return {
            start,
            end,
            rect
        };
    }
    const rect = fakeRanges[0].getBoundingClientRect();
    fakeClone.remove();
    return {
        start: options.selectionStart,
        end: options.selectionEnd,
        rect
    };
    // Local functions for readability of the previous code
    function appendPart(start, end) {
        const span = document.createElement("span");
        let tmpText = text.substring(start, end);
        span.style.cssText = cssDefaultStyles; // Force styles to prevent unexpected results
        // add a space if it ends in a newline
        if (/[\n\r]$/.test(tmpText)) {
            tmpText += " ";
        }
        span.textContent = tmpText;
        fakeClone.appendChild(span);
        return span;
    }
    // Computing offset position
    function getInputOffset() {
        const body = document.body;
        const win = document.defaultView;
        const docElem = document.documentElement;
        let box = document.createElement("div");
        box.style.paddingLeft = box.style.width = "1px";
        body.appendChild(box);
        const isBoxModel = box.offsetWidth == 2;
        body.removeChild(box);
        box = input.getBoundingClientRect();
        const clientTop = docElem.clientTop || body.clientTop || 0;
        const clientLeft = docElem.clientLeft || body.clientLeft || 0;
        const scrollTop = win.offsetY || (isBoxModel && docElem.scrollTop) || body.scrollTop;
        const scrollLeft = win.offsetX || (isBoxModel && docElem.scrollLeft) || body.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    function getInputCSS(prop, isnumber) {
        const val = document.defaultView.getComputedStyle(input, null).getPropertyValue(prop);
        return isnumber ? parseFloat(val) : val;
    }
}
